// import '@/assets/scss/app.scss';
import reportWebVitals from '@/config/reportWebVitals';
import { Router } from '@/lib/router-dom';
import store from '@/redux/store.js';
import { hydrateShellSession } from '@/redux/actions/auth.js';
import axios from 'axios';
import React from 'react';
import { initResizeObserverErrorHandler } from './utils/resize-observer-error-handler';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';

axios.defaults.headers.common['Channel'] = 'UI';

const SHELL_HOSTED = process.env.REACT_APP_SHELL_HOSTED === 'true';

// Shell-hosted: hydrate Authorization header from sessionStorage BEFORE the
// router mounts so the very first API call goes out authenticated.
if (SHELL_HOSTED) {
    const token = typeof window !== 'undefined' ? sessionStorage.getItem('pitstopCoreToken') : null;
    if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
}

// Initialize the ResizeObserver error handler to suppress loop errors
initResizeObserverErrorHandler();

function renderApp() {
    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <Router basename={process.env.PUBLIC_URL}>
                    <App />
                </Router>
            </Provider>
        </React.StrictMode>,
        document.getElementById('root')
    );
    reportWebVitals();
}


// Portal pre-fetches profile/features/orgsys at login.
// If any required key is missing here, force re-login via portal.
const pitstopToken = typeof window !== 'undefined' ? sessionStorage.getItem('pitstopCoreToken') : null;
const hasProfile = typeof window !== 'undefined' && !!sessionStorage.getItem('profile');
const hasFeatures = typeof window !== 'undefined' && !!sessionStorage.getItem('features');
const hasOrgsys = typeof window !== 'undefined' && !!sessionStorage.getItem('orgsys');
const hasNavEntries = typeof window !== 'undefined' && !!sessionStorage.getItem('navEntries');

const shouldRedirectToLogin =
    SHELL_HOSTED &&
    typeof window !== 'undefined' &&
    !!pitstopToken &&
    (!hasProfile || !hasFeatures || !hasOrgsys || !hasNavEntries);

if (shouldRedirectToLogin) {
    console.warn('[pitstop-ui] Hydrate prerequisites missing — redirecting to portal /login', {
        hasProfile,
        hasFeatures,
        hasOrgsys,
        hasNavEntries,
        pathname: window.location.pathname,
    });
    window.location.assign('/login');
} else {
    const shouldHydrate =
        SHELL_HOSTED &&
        typeof window !== 'undefined' &&
        !!pitstopToken &&
        sessionStorage.getItem('profileSurface') !== 'pitstop';

    (async () => {
        if (shouldHydrate) {
            try {
                await store.dispatch(hydrateShellSession());
            } catch (_e) { /* let 401 interceptor handle */ }
        }
        renderApp();
    })();
}
